import {observable} from 'mobx';
import {construct, createArrayInstance, createInstance, ModelProperties} from 'utils';

import {LocaleHint} from './locale-hint';
import {SeoLocaleContent} from './seo-locale-content';
import {SeoLocaleCategory} from './seo-locale-category';
import {SeoLocaleKeyHints} from './seo-locale-key-hint';

export class SeoLocaleKey {
    @observable id!: number;

    @observable name!: string;

    @observable whitespaces: boolean = true;

    @observable charLimit: number = 0;

    @observable enabled: boolean = true;

    @observable categoryId!: number;

    @observable hints?: SeoLocaleKeyHints[];

    @observable category?: SeoLocaleCategory;

    @observable content?: SeoLocaleContent[];

    constructor(key?: ModelProperties<SeoLocaleKey>) {
        if (key) {
            construct(this, key);
            this.category = createInstance(SeoLocaleCategory, key.category);
            this.content = createArrayInstance(SeoLocaleContent, key.content);
            this.hints = createArrayInstance(SeoLocaleKeyHints, key.hints);
        }
    }
}